//global variables for the application

export const VARIABLES = {
  ROLE: {
    ADMIN: "ROLE_ADMIN",
    MOBILITY_MANAGER: "ROLE_MOBILITY_MANAGER",
    APP_USER: "ROLE_APP_USER",
  },

  STATS: {
    NAME: {
      EMPLOYEES_PARTECIPATION: "Partecipazione dipendenti",
      ENVIRONMENTAL_IMPACT: "Impatto ambientale",
      POINTS_COUNTED: "Punteggio campagna",
      PERFORMANCE_KM: "Performance KM totali",
      PERFORMANCE_HOURS: "Performance ore totali",
      TRIPS: "Viaggi",
      MULTI: "Multimodalità",
    },
    DESCRIPTION: {
      EMPLOYEES_PARTECIPATION: " missing description",
      ENVIRONMENTAL_IMPACT: "Questa statistica include tutti i viaggi validati indipendentemente dal loro contributo in termini di punti, dunque include anche viaggi che, in base ai limiti impostati per la campagna, non hanno prodotto alcun punteggio utile. Si precisa che i valori di CO2 esposti sono indicativi e vengono computati in base alle indicazioni fornite dal Ministero / EU.",
      POINTS_COUNTED: "missing description",
      PERFORMANCE_KM: "Questa statistica include tutti i viaggi validati indipendentemente dal loro contributo in termini di punti, dunque include anche viaggi che, in base ai limiti impostati per la campagna, non hanno prodotto alcun punteggio utile.",
      PERFORMANCE_HOURS: "Questa statistica include tutti i viaggi validati indipendentemente dal loro contributo in termini di punti, dunque include anche viaggi che, in base ai limiti impostati per la campagna, non hanno prodotto alcun punteggio utile.",
      TRIPS: "Questa statistica include tutti i viaggi validati indipendentemente dal loro contributo in termini di punti, dunque include anche viaggi che, in base ai limiti impostati per la campagna, non hanno prodotto alcun punteggio utile.",
      MULTI: "Questa statistica include tutti i viaggi validati indipendentemente dal loro contributo in termini di punti, dunque include anche viaggi che, in base ai limiti impostati per la campagna, non hanno prodotto alcun punteggio utile.",
    },
    VIEWS: {
      DATACOLUMNS: {
        REGISTERED_EMPLOYEES: {
          label: "Iscrizioni",
          value: "registration",
          source: 'employee'
        },
        ACTIVE_EMPLOYEES: {
          label: "Attivi",
          value: "activeUsers",
          source: 'employee'
        },
        UNSUBSCRIBED_EMPLOYEES: {
          label: "Abbandoni",
          value: "dropout",
          source: 'employee'
        },
        REGISTERED_EMPLOYEES_PERCENTAGE: {
          label: "Percentuale dipendenti registrati",
          value: "registration__prcTot",
          baseValue: "registration",
          source: "employee"
        },
        //nuovi
        REGISTRATION_PROGRESSIVE: {
          label: "Progressivo iscrizioni",
          value: "registration__progressive",
          source: "employee"

        },
        DROPOUT_PROGRESSIVE: {
          label: "Progressivo abbandoni",
          value: "dropout__progressive",
          source: "employee"

        },
        REGISTERED_PROGRESSIVE: {
          label: "Iscritti attuali",
          value: "registered__progressive",
          source: "employee"

        },
        //fine nuovi
        ACTIVE_EMPLOYEES_PERCENTAGE: {
          label: "Percentuale dipendenti attivi",
          value: "activeUsers__prcTot",
          baseValue: "activeUsers",
          source: "employee"
        },
        UNSUBSCRIBED_EMPLOYEES_PERCENTAGE: {
          label: "Percentuale dipendenti rimossi",
          value: "dropout__prcTot",
          baseValue: "dropout",
          source: "employee"
        },
        ACTIVE_EMPLOYEES_PERCENTAGE_REGISTRATION: {
          label: "Percentuale dipendenti attivi su registrati",
          value: "activeUsers__prcRegistered",
          baseValue: "activeUsers",
          source: "employee"
        },
        UNSUBSCRIBED_EMPLOYEES_PERCENTAGE_REGISTRATION: {
          label: "Percentuale dipendenti rimossi su registrati",
          value: "dropout__prcRegistered",
          baseValue: "dropout",
          source: "employee"
        },
        POINTS: {
          label: "Punti potenziali",
          meanLabel: "Potenziali per mezzo (_mezzo_)",
          value: "score",
          source: "tracks"
        },
        COUNTING_POINTS: {
          label: "Punti",
          meanLabel: "Punti per mezzo (_mezzo_)",
          value: "limitedScore",
          source: "tracks"
        },
        N_COUNTING_TRAVEL: {
          label: "Viaggi utili",
          value: "limitedTripCount",
          source: "tracks"
        },
        N_TRAVEL: {
          label: "Viaggi totali",
          meanLabel: "Tratte per mezzo (_mezzo_)",
          value: "tripCount",
          source: "tracks"
        },
        N_TRAVEL_SINGLE: {
          label: "Viaggi monomodali",
          value: "singleCount",
          baseValue: "tripCount",
          source: "tracks"
        },
        N_TRAVEL_MULTI: {
          label: "Viaggi multimodali",
          value: "multimodalCount",
          baseValue: "tripCount",
          source: "tracks"
        },
        DISTANCE: {
          label: "Distanza totale (km)",
          meanLabel: "KM per mezzo (_mezzo_)",
          value: "distance",
          source: "tracks"
        },
        DISTANCE_AVG_LEG: {
          label: "Distanza media per tratta (km)",
          meanLabel: "KM per mezzo (_mezzo_) per tratta",
          value: "distance__avgTrack",
          baseValue: "distance",
          source: "tracks"
        },
        DISTANCE_AVG_TRIP: {
          label: "Distanza media per viaggio (km)",
          meanLabel: "KM per mezzo (_mezzo_) per viaggio",
          value: "distance__avgTrip",
          baseValue: "distance",
          source: "tracks"
        },
        DISTANCE_PERCENTAGE: {
          label: "Percentuale distanza tracciata",
          meanLabel: "Percentuale distanza tracciata per mezzo (_mezzo_)",
          value: "distance__prcValue",
          baseValue: "distance",
          source: "tracks"
        },
        DISTANCE_PERCENTAGE_AVG_TRIP: {
          label: "Percentuale distanza media per viaggio",
          meanLabel: "Percentuale distanza media per viaggio per mezzo (_mezzo_)",
          value: "distance__prcAvgTrip",
          baseValue: "distance",
          source: "tracks"
        },
        DISTANCE_PERCENTAGE_AVG_LEG: {
          label: "Percentuale distanza media per tratta",
          meanLabel: "Percentuale distanza media per tratta per mezzo (_mezzo_)",
          value: "distance__prcAvgTrack",
          baseValue: "distance",
          source: "tracks"
        },
        DURATION: {
          label: "Durata totale (ore)",
          meanLabel: "Ore per mezzo (_mezzo_)",
          value: "duration",
          source: "tracks"
        },
        DURATION_AVG_LEG: {
          label: "Durata media per tratta (ore)",
          meanLabel: "Ore per mezzo (_mezzo_) per tratta",
          value: "duration__avgTrack",
          baseValue: "duration",
          source: "tracks"
        },
        DURATION_AVG_TRIP: {
          label: "Durata media per viaggio (ore)",
          meanLabel: "Ore per mezzo (_mezzo_) per viaggio",
          value: "duration__avgTrip",
          baseValue: "duration",
          source: "tracks"
        },
        DURATION_PERCENTAGE: {
          label: "Percentuale durata tracciata",
          meanLabel: "Percentuale durata tracciata per mezzo (_mezzo_)",
          value: "duration__prcValue",
          baseValue: "duration",
          source: "tracks"
        },
        DURATION_PERCENTAGE_AVG_TRIP: {
          label: "Percentuale durata media per viaggio",
          meanLabel: "Percentuale durata media per viaggio per mezzo (_mezzo_)",
          value: "duration__prcAvgTrip",
          baseValue: "duration",
          source: "tracks"
        },
        DURATION_PERCENTAGE_AVG_LEG: {
          label: "Percentuale durata media per tratta",
          meanLabel: "Percentuale durata media per tratta per mezzo (_mezzo_)",
          value: "duration__prcAvgTrack",
          baseValue: "duration",
          source: "tracks"
        },
        CO2_SAVED: {
          label: "kg CO2 risparmiata",
          meanLabel: "CO2 per mezzo (_mezzo_)",
          value: "co2",
          source: "tracks"
        },
        CO2_SAVED_AVG_LEG: {
          label: "kg CO2 media per tratta",
          meanLabel: "CO2 per mezzo (_mezzo_) per tratta",
          value: "co2__avgTrack",
          baseValue: "co2",
          source: "tracks"
        },
        CO2_SAVED_AVG_TRIP: {
          label: "kg CO2 media per viaggio",
          meanLabel: "CO2 per mezzo (_mezzo_) per viaggio",
          value: "co2__avgTrip",
          baseValue: "co2",
          source: "tracks"
        },
        CO2_SAVED_PERCENTAGE: {
          label: "Percentuale CO2 risparmiata",
          meanLabel: "Percentuale CO2 risparmiata per mezzo (_mezzo_)",
          value: "co2__prcValue",
          baseValue: "co2",
          source: "tracks"
        },
        CO2_SAVED_PERCENTAGE_AVG_TRIP: {
          label: "Percentuale CO2 media per viaggio",
          meanLabel: "Percentuale CO2 media per viaggio per mezzo (_mezzo_)",
          value: "co2__prcAvgTrip",
          baseValue: "co2",
          source: "tracks"
        },
        CO2_SAVED_PERCENTAGE_AVG_LEG: {
          label: "Percentuale CO2 media per tratta",
          meanLabel: "Percentuale CO2 media per tratta per mezzo (_mezzo_)",
          value: "co2__prcAvgTrack",
          baseValue: "co2",
          source: "tracks"
        },
        MM_TRAVEL: {
          label: "Viaggi",
          value: "count",
          source: "multimodal"
        },
        MM_DURATION: {
          label: "Durata (ore)",
          value: "duration",
          source: "multimodal"
        },
        MM_DISTANCE: {
          label: "Distanza (km)",
          value: "distance",
          source: "multimodal"
        },
        MM_DURATION_AVG: {
          label: "Durata media (ore)",
          value: "duration_avg",
          source: "multimodal"
        },
        MM_DISTANCE_AVG: {
          label: "Distanza media (km)",
          value: "distance_avg",
          source: "multimodal"
        },
        MM_COUNT_PRC: {
          label: "Percentuale viaggi",
          value: "prcCount",
          source: "multimodal"
        },
        MM_DURATION_PRC: {
          label: "Percentuale durata",
          value: "prcDuration",
          source: "multimodal"
        },
        MM_DISTANCE_PRC: {
          label: "Percentuale distanza",
          value: "prcDistance",
          source: "multimodal"
        },
      },
      DATALEVEL: {
        LOCATIONS: "Sede",
        COMPANY: "Azienda",
        EMPLOYEES: "Dipendente",
        CAMPAIGN: "Campagna",
        COMPANIES: "Azienda",
      },
      TIMEUNIT: {
        HOUR: "Fascia oraria",
        DOW: "Giorno della settimana",
        DAY: "Giorno",
        WEEK: "Settimana",
        MONTH: "Mese",
        YEAR: "Anno",
        CAMPAIGN: "Campagna",
      },
      TIMEPERIOD: {
        ALL: "Intera durata campagna",
        SPECIFIC: "Imposta periodo"
      },
      PUNTUALAGGREGATION: {
        NONE: "Nessuno",
        EMPLOYEES: "Selezione dipendente/i",
        LOCATIONS: "Sedi",
        COMPANIES: "Aziende",
      },
    },
  },
};
